// extracted by mini-css-extract-plugin
export default {"bodyBackground":"styles_bodyBackground__UnUiO","container":"styles_container__egfJJ","logo":"styles_logo__8hMBT","article":"styles_article__O-S0s"};